const home = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
    >
      <g clipPath="url(#clip0_107_4487)">
        <path
          d="M29.681 12.1913L15.4605 1.77934C15.1863 1.5786 14.8138 1.5786 14.5397 1.77934L0.319077 12.1913C-0.0282669 12.4456 -0.103736 12.9334 0.15062 13.2807C0.404975 13.6281 0.892768 13.7034 1.24005 13.4492L15 3.37432L28.76 13.4491C28.8988 13.5508 29.06 13.5997 29.2199 13.5997C29.4599 13.5997 29.6967 13.4892 29.8494 13.2807C30.1038 12.9334 30.0283 12.4456 29.681 12.1913Z"
          fill="#56585D"
        />
        <path
          d="M25.9127 13.6256C25.4823 13.6256 25.1333 13.9746 25.1333 14.4051V26.8123H18.8976V20.0396C18.8976 17.8904 17.149 16.142 14.9999 16.142C12.8508 16.142 11.1023 17.8905 11.1023 20.0396V26.8123H4.86656V14.4051C4.86656 13.9747 4.51752 13.6257 4.08709 13.6257C3.65666 13.6257 3.30762 13.9747 3.30762 14.4051V27.5918C3.30762 28.0223 3.65666 28.3713 4.08709 28.3713H11.8818C12.2917 28.3713 12.6271 28.0546 12.6582 27.6525C12.6601 27.6343 12.6612 27.6144 12.6612 27.5918V20.0397C12.6612 18.7501 13.7104 17.701 14.9999 17.701C16.2895 17.701 17.3387 18.7502 17.3387 20.0397V27.5918C17.3387 27.6143 17.3398 27.6339 17.3417 27.6518C17.3724 28.0542 17.708 28.3713 18.1181 28.3713H25.9128C26.3433 28.3713 26.6923 28.0223 26.6923 27.5918V14.4051C26.6922 13.9746 26.3432 13.6256 25.9127 13.6256Z"
          fill="#56585D"
        />
      </g>
      <defs>
        <clipPath id="clip0_107_4487">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const movie = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7439 10.0125H30.2564V10C31.3064 10 32.1668 10.737 32.1668 11.6365V28.3635C32.1668 29.263 31.3064 30 30.2564 30H10.7439C9.69391 30 8.8335 29.263 8.8335 28.3635V11.649C8.8335 10.7495 9.69391 10.0125 10.7439 10.0125ZM30.8543 18.5572H29.2356V21.4553H30.8543V18.5572ZM29.2356 17.4453H30.8543V14.5472H29.2356V17.4453ZM30.8543 22.5796H29.2356V25.4778H30.8543V22.5796ZM30.8543 13.4354V11.649C30.8543 11.3741 30.5918 11.1368 30.2564 11.1368H29.2356V13.4354H30.8543ZM11.7502 18.5572H10.1314V21.4553H11.7502V18.5572ZM10.1314 17.4453H11.7502V14.5472H10.1314V17.4453ZM11.7502 22.5796H10.1314V25.4778H11.7502V22.5796ZM11.7502 11.1368H10.7293C10.4085 11.1368 10.1314 11.3616 10.1314 11.649V13.4354H11.7502V11.1368ZM10.1314 26.5896V28.376C10.1314 28.6508 10.3939 28.8882 10.7293 28.8882H11.7502V26.5896H10.1314ZM13.0627 26.065V28.8757H27.9377V11.1243H13.0627V13.96V13.9975V14.035V17.97V18.0075V18.045V21.98V22.0175V22.055V25.99V26.0275V26.065ZM29.2356 28.8882H30.2564C30.5772 28.8882 30.8543 28.6633 30.8543 28.376V26.5896H29.2356V28.8882ZM18.4439 16.509L23.1981 18.8575V18.87C23.6793 19.1073 23.971 19.5446 23.971 20.0193C23.971 20.494 23.6793 20.9312 23.1981 21.1685L18.4439 23.5171C18.196 23.6295 17.9335 23.692 17.671 23.692C17.4085 23.692 17.146 23.642 16.8981 23.5171C16.4168 23.2797 16.1252 22.8425 16.1252 22.3678V17.6582C16.1252 17.1835 16.4168 16.7463 16.8981 16.509C17.3793 16.2716 17.9627 16.2716 18.4439 16.509ZM17.7877 22.5302L22.5418 20.1817L22.5272 20.1692C22.6293 20.1192 22.6439 20.0318 22.6439 19.9943C22.6439 19.9568 22.6293 19.8694 22.5272 19.8194L17.7731 17.4709C17.7293 17.4459 17.7002 17.4459 17.6564 17.4459C17.6127 17.4459 17.5689 17.4584 17.5397 17.4709C17.496 17.4833 17.4231 17.5458 17.4231 17.6457V22.3553C17.4231 22.4552 17.496 22.5052 17.5397 22.5302C17.5835 22.5552 17.6856 22.5802 17.7877 22.5302Z"
        fill="#56585D"
      />
    </svg>
  );
};
const book = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
    >
      <path
        d="M34.4832 12.6667H32.4332V10.6333C32.4332 10.2833 32.1498 10 31.7998 10H25.1332C23.3165 10 21.8998 10.8167 21.1332 12.1667C20.3665 10.8167 18.9498 10 17.1332 10H10.4665C10.1165 10 9.83316 10.2833 9.83316 10.6333V12.6667H7.79982C7.44982 12.6667 7.1665 12.95 7.1665 13.3V27.3C7.1665 27.65 7.44982 27.9333 7.79982 27.9333H16.8831L18.0332 29.0833C18.1498 29.2 18.3165 29.2667 18.4832 29.2667H23.8165C23.9832 29.2667 24.1498 29.2 24.2665 29.0833L25.4165 27.9333H34.4998C34.8498 27.9333 35.1332 27.65 35.1332 27.3V13.3C35.1332 12.95 34.8498 12.6667 34.4998 12.6667H34.4832ZM25.1498 11.25H31.1832V24H25.1498C24.2165 24 22.9332 24.15 22.1332 25.3333H21.7832V14.6167C21.7832 12.9833 22.6665 11.25 25.1498 11.25ZM11.1165 11.25H17.1498C19.6332 11.25 20.5332 13 20.5332 14.6167V25.3333H20.1832C19.3832 24.15 18.0998 24 17.1665 24H11.1332V11.25H11.1165ZM33.8665 26.6667H25.1498C24.9832 26.6667 24.8165 26.7333 24.6998 26.85L23.5498 28H18.7331L17.5832 26.85C17.4665 26.7333 17.2998 26.6667 17.1332 26.6667H8.4165V13.9167H9.83316V24.6167C9.83316 24.9667 10.1165 25.25 10.4665 25.25H17.1332C18.2665 25.25 18.8832 25.5333 19.2498 26.25C19.3498 26.45 19.5665 26.5833 19.7998 26.5833H22.4665C22.6998 26.5833 22.9165 26.45 23.0165 26.25C23.3832 25.55 23.9832 25.25 25.1332 25.25H31.7998C32.1498 25.25 32.4332 24.9667 32.4332 24.6167V13.9167H33.8498V26.6667H33.8665Z"
        fill="#56585D"
      />
    </svg>
  );
};
const party = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6986 11.5426C16.784 11.8559 17.0546 12.0553 17.368 12.0553C17.4249 12.0553 17.4819 12.0553 17.5389 12.0268C17.9092 11.9271 18.1228 11.5568 18.0374 11.1865L17.4249 8.85073C17.3252 8.48043 16.9549 8.26679 16.5846 8.35225C16.2143 8.45194 16.0007 8.82225 16.0861 9.19255L16.6986 11.5283V11.5426ZM18.55 12.055C18.664 12.1262 18.7779 12.1547 18.8919 12.1547C19.134 12.1547 19.3619 12.0265 19.49 11.8129L20.8716 9.44865C21.0567 9.12107 20.957 8.6938 20.6294 8.50864C20.3019 8.30925 19.8746 8.42319 19.6894 8.75077L18.3079 11.115C18.1228 11.4426 18.2225 11.8699 18.55 12.055ZM11.4292 21.4692C11.1444 22.338 11.1586 23.278 11.4862 24.0898C11.7283 24.7023 12.1414 25.2007 12.6398 25.5283L11.3865 29.3738L9.73437 28.8326C9.37831 28.7186 8.97952 28.918 8.86558 29.2741C8.75164 29.6302 8.95104 30.0289 9.3071 30.1429L13.9074 31.6383C13.9074 31.6383 14.0498 31.6668 14.1211 31.6668C14.4059 31.6668 14.6765 31.4817 14.7762 31.1968C14.8902 30.8408 14.6908 30.442 14.3347 30.328L12.6826 29.7868L13.9359 25.9271C13.9359 25.9271 14.0214 25.9556 14.0641 25.9556C14.6195 25.9556 15.1892 25.7847 15.702 25.4571C16.4426 24.9871 17.0123 24.2465 17.3114 23.3777L19.6187 16.2849L13.708 14.3622L11.4007 21.455L11.4292 21.4692ZM17.9096 17.1822L16.9268 20.2016H13.9644C13.5798 20.2016 13.2808 20.515 13.2808 20.8853C13.2808 21.2556 13.5941 21.5689 13.9644 21.5689H16.4853L16.0296 22.9504C15.8444 23.5201 15.4599 24.0044 14.9899 24.3035C14.5483 24.5741 14.0926 24.6595 13.6938 24.5171C13.2808 24.3747 12.9532 24.0471 12.768 23.5629C12.5686 23.0501 12.5544 22.4377 12.7395 21.8822L14.6195 16.0998L17.9096 17.168V17.1822ZM15.7444 12.7956L13.3802 11.4141C13.0526 11.2289 12.9529 10.8016 13.1381 10.4741C13.3232 10.1465 13.7505 10.0325 14.0781 10.2319L16.4423 11.6134C16.7699 11.7986 16.8696 12.2259 16.6844 12.5535C16.5563 12.7671 16.3284 12.8953 16.0863 12.8953C15.9723 12.8953 15.8584 12.8668 15.7444 12.7956ZM30.6139 24.8163C30.9415 24.6312 31.3545 24.7594 31.5397 25.0869V25.0727C31.7248 25.4003 31.5966 25.8133 31.2691 25.9985L27.0106 28.3057C26.9109 28.3627 26.7969 28.3912 26.683 28.3912C26.4409 28.3912 26.213 28.263 26.0848 28.0351C25.8996 27.7076 26.0278 27.2945 26.3554 27.1094L27.8793 26.2833L25.9566 22.7227C25.743 22.7654 25.5293 22.7939 25.3157 22.7939C24.1051 22.7939 22.8375 22.0533 22.1681 20.8L18.6217 14.2484L24.0766 11.3002L27.623 17.866C28.0645 18.6778 28.2069 19.5893 28.036 20.4581C27.9078 21.1133 27.5945 21.6687 27.1672 22.0818L29.09 25.6424L30.6139 24.8163ZM20.4875 14.8039L23.3787 20.159V20.1448C23.9342 21.1845 25.1305 21.7115 25.9566 21.27C26.3269 21.0706 26.5833 20.686 26.683 20.1733C26.7827 19.6321 26.6972 19.0196 26.4124 18.4927L26.2557 18.1936H23.1508C22.7805 18.1936 22.4672 17.8802 22.4672 17.5099C22.4672 17.1396 22.7663 16.8263 23.1508 16.8263H25.5151L23.5354 13.1517L20.4875 14.8039Z"
        fill="#56585D"
      />
    </svg>
  );
};
const pen = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <mask
        id="mask0_107_4507"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="14"
      >
        <rect width="14" height="14" fill="#56585D" />
      </mask>
      <g mask="url(#mask0_107_4507)">
        <path
          d="M1.1665 14V11.6667H12.8332V14H1.1665ZM2.33317 10.5V8.31254L7.61234 3.03337L9.79984 5.22087L4.52067 10.5H2.33317ZM3.49984 9.33337H4.02484L8.1665 5.22087L7.61234 4.66671L3.49984 8.80837V9.33337ZM10.4561 4.57921L8.26859 2.39171L9.31859 1.34171C9.42553 1.22504 9.56164 1.16914 9.72692 1.174C9.8922 1.17886 10.0283 1.23476 10.1353 1.34171L11.5061 2.71254C11.613 2.81948 11.6665 2.95316 11.6665 3.11358C11.6665 3.274 11.613 3.41254 11.5061 3.52921L10.4561 4.57921Z"
          fill="#56585D"
        />
      </g>
    </svg>
  );
};
const add = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <mask
        id="mask0_217_17112"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="30"
      >
        <rect width="30" height="30" fill="#919499" />
      </mask>
      <g mask="url(#mask0_217_17112)">
        <path
          d="M13.75 23.75V16.25H6.25V13.75H13.75V6.25H16.25V13.75H23.75V16.25H16.25V23.75H13.75Z"
          fill="#56585D"
        />
      </g>
    </svg>
  );
};

const backpage = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.8086 6.14632L4.46391 11.4873C4.45193 11.4972 4.4403 11.5078 4.42907 11.519L4.14632 11.802C3.95113 11.9973 3.95124 12.3139 4.14657 12.5091L9.8054 18.164C10.0007 18.3592 10.3173 18.3591 10.5125 18.1637L10.7952 17.8808C10.9904 17.6855 10.9903 17.3689 10.795 17.1737L6.4655 12.8472H19.7867C19.9082 12.8472 20.0067 12.7487 20.0067 12.6272V11.6672C20.0067 11.5457 19.9082 11.4472 19.7867 11.4472H6.48461L10.7982 7.13662C10.9935 6.94142 10.9936 6.62484 10.7984 6.42951L10.5157 6.14657C10.3205 5.95124 10.0039 5.95113 9.8086 6.14632Z"
        fill="#56585D"
      />
    </svg>
  );
};

const group = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="12"
      viewBox="0 0 22 12"
      fill="none"
    >
      <rect x="0.5" width="21" height="2" rx="1" fill="#D9D9D9" />
      <rect x="0.5" y="5" width="21" height="2" rx="1" fill="#D9D9D9" />
      <rect x="0.5" y="10" width="21" height="2" rx="1" fill="#D9D9D9" />
    </svg>
  );
};

const cross = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.1037 11.997L18.7737 6.32471C18.8462 6.25235 18.9037 6.16639 18.9429 6.07176C18.9822 5.97713 19.0024 5.87568 19.0024 5.77324C19.0024 5.67079 18.9822 5.56934 18.9429 5.47472C18.9037 5.38009 18.8462 5.29413 18.7737 5.22176C18.6254 5.07946 18.4279 5 18.2224 5C18.017 5 17.8194 5.07946 17.6712 5.22176L12.0012 10.9028L6.33118 5.22176C6.18292 5.07946 5.9854 5 5.77993 5C5.57446 5 5.37695 5.07946 5.22868 5.22176C5.15619 5.29413 5.09868 5.38009 5.05944 5.47472C5.0202 5.56934 5 5.67079 5 5.77324C5 5.87568 5.0202 5.97713 5.05944 6.07176C5.09868 6.16639 5.15619 6.25235 5.22868 6.32471L10.8987 11.997L5.22868 17.678C5.15646 17.7497 5.09913 17.8349 5.06001 17.9288C5.02088 18.0227 5.00074 18.1234 5.00074 18.2251C5.00074 18.3269 5.02088 18.4276 5.06001 18.5215C5.09913 18.6154 5.15646 18.7006 5.22868 18.7722C5.2999 18.8462 5.38564 18.9046 5.48051 18.9437C5.57538 18.9829 5.67732 19.002 5.77993 18.9998C5.88226 19 5.98361 18.98 6.0782 18.9409C6.17278 18.9019 6.25875 18.8445 6.33118 18.7722L12.0012 13.0999L17.6712 18.7722C17.7436 18.8445 17.8296 18.9019 17.9242 18.9409C18.0188 18.98 18.1201 19 18.2224 18.9998C18.325 19.002 18.427 18.9829 18.5219 18.9437C18.6167 18.9046 18.7025 18.8462 18.7737 18.7722C18.8459 18.7006 18.9032 18.6154 18.9424 18.5215C18.9815 18.4276 19.0016 18.3269 19.0016 18.2251C19.0016 18.1234 18.9815 18.0227 18.9424 17.9288C18.9032 17.8349 18.8459 17.7497 18.7737 17.678L13.1037 11.997Z"
        fill="#56585D"
      />
    </svg>
  );
};

const more_than = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clipPath="url(#clip0_522_939)">
        <path
          d="M13.0599 8.00004C13.0599 8.2868 12.9504 8.57351 12.7319 8.79213L5.85219 15.6718C5.41455 16.1094 4.705 16.1094 4.26755 15.6718C3.83009 15.2343 3.83009 14.5249 4.26755 14.0872L10.3551 8.00004L4.26776 1.91282C3.8303 1.47518 3.8303 0.765843 4.26776 0.328421C4.70522 -0.109427 5.41477 -0.109427 5.8524 0.328421L12.7321 7.20795C12.9507 7.42668 13.0599 7.7134 13.0599 8.00004Z"
          fill="#56585D"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_939">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5 16) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const sceneicon = {
  home,
  movie,
  book,
  party,
  pen,
  add,
  backpage,
  group,
  cross,
  more_than,
};
export default sceneicon;
